export default __webpack_public_path__ + "f60bf8fcbef85cc550dc90d2052dc62d.jpg";